import { Provider as JotaiProvider } from 'jotai';
import { ReactNode } from 'react';

import { jotaiStore } from './jotaiStore';

interface JotaiProviderProps {
  children: ReactNode;
}

export const AppJotaiProvider = ({ children }: JotaiProviderProps) => {
  // Use the same store instance for the provider
  return <JotaiProvider store={jotaiStore}>{children}</JotaiProvider>;
};
